// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'e164d7d0';
